import { useTranslation } from "react-i18next";
import { FormContactsDataList } from "@/pages/ContactsPage/Components/FormContactsDataList";
import { useAppSelector } from "@/services/store";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import { EmailField, LinkField, PhoneField } from "../Fields";

export const LeftSectionList = () => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);
  if (!currentPerson) return <></>;

  return (
    <>
      <FormContactsDataList
        title={t("contactsPage.generalInfo.phones")}
        fieldArrayName={"phones"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.phoneType?.name ?? "",
          value: item?.number ?? "",
        })}
        editNode={(index) => <PhoneField index={index} />}
        addableModel={{ phoneType: { name: "" }, number: "", id: "", personId: currentPerson?.id }}
      />
      <FormContactsDataList
        title={t("contactsPage.generalInfo.emails")}
        fieldArrayName={"emails"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.emailType?.name ?? "",
          value: item?.email ?? "",
        })}
        editNode={(index) => <EmailField index={index} />}
        addableModel={{ emailType: { name: "" }, email: "", id: "", personId: currentPerson?.id }}
      />
      <FormContactsDataList
        title={t("contactsPage.generalInfo.websites")}
        fieldArrayName={"websites"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.websiteType?.name ?? "",
          value: item?.websiteAddress ?? "",
        })}
        editNode={(index) => <LinkField index={index} />}
        addableModel={{
          websiteType: { name: "" },
          websiteAddress: "",
          id: "",
          personId: currentPerson?.id,
        }}
      />
    </>
  );
};
